import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import {Button} from "@mui/material";
import ReactPlayer from "react-player";

export const ConventionLandingStep = observer((props) => {
    const {generalStore} = useStores();

    return (
        <div className='on-boarding-step convention landing'>
            <div className='step-description'>
                    <span>
                        ROTAX&nbsp;{generalStore.translate('hasAdoptedThe', true)}&nbsp;
                        <b>frontline.io</b>&nbsp;{generalStore.translate('platformToEnableItsDistributors', true)},
                        &nbsp;{generalStore.translate('trainingInstitutes', true)},&nbsp;
                        {generalStore.translate('flightSchools', true)},&nbsp;
                        {generalStore.translate('serviceCentersAndPilots', true)},&nbsp;
                        {generalStore.translate('toUnlockThePotentialOfThe', true)}&nbsp;
                        <b>{generalStore.translate('digitalAndVirtualWorlds', true)}</b>
                    </span>
            </div>
            <div className='step-description'>
                    <span>
                        <b>frontline.io</b>&nbsp;{generalStore.translate('allowsYouToHaveA')}&nbsp;
                        {generalStore.translate('completeEngineInThePalmOfYourHands', true)}
                    </span>
            </div>
            <div className='step-form-line'>
                <ReactPlayer
                    className='video-container'
                    config={{file: {attributes: {controlsList: 'nodownload'}}}}
                    onContextMenu={e => e.preventDefault()}
                    url='https://storage.googleapis.com/procedureio.appspot.com/Rotax%20AR%20-%20Salon%20BGSHORT3.mp4'
                    height="none"
                    width="none"
                    playing
                    loop
                    muted
                />
            </div>
            <div className='step-form-line submit-container'>
                <div className='step-description column'>
                    <div>
                        <b>{generalStore.translate('signUpForA')}&nbsp;{generalStore.translate('freeTrial', true)}.&nbsp;</b>
                    </div>
                    <div><b>{generalStore.translate('noCreditCardNeeded')}</b></div>
                </div>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={() => props.goToNextStep()}
                >
                    {generalStore.translate('freeTrial')}
                </Button>
            </div>
        </div>
    )
});
